"use strict";

exports.__esModule = true;
exports.createTypography = exports.fontFamily = void 0;

var lodash_1 = require("lodash");

var systemFont = ['-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Roboto', '"Helvetica Neue"', 'Arial', 'sans-serif', '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(',');
exports.fontFamily = {
  system: systemFont,
  depotNew: 'depot-new-web'
};

exports.createTypography = function (options, breakpoints) {
  var _a, _b, _c, _d;

  if (options === void 0) {
    options = {};
  }

  return lodash_1.merge({
    fontFamily: exports.fontFamily.system,
    displayExtraLarge: (_a = {
      fontSize: 56,
      fontWeight: 700,
      lineHeight: 68 / 56
    }, _a[breakpoints.sm] = {
      fontSize: 29,
      lineHeight: 36 / 29
    }, _a),
    displayLarge: (_b = {
      fontSize: 40,
      fontWeight: 700,
      lineHeight: 52 / 40
    }, _b[breakpoints.sm] = {
      fontSize: 25,
      lineHeight: 28 / 25
    }, _b),
    displayMedium: (_c = {
      fontSize: 30,
      fontWeight: 700,
      lineHeight: 36 / 30
    }, _c[breakpoints.sm] = {
      fontSize: 22,
      lineHeight: 28 / 22
    }, _c),
    displaySmall: (_d = {
      fontSize: 22,
      fontWeight: 300,
      lineHeight: 30 / 22
    }, _d[breakpoints.sm] = {
      fontSize: 18,
      lineHeight: 24 / 18
    }, _d),
    heading: {
      fontSize: 22,
      fontWeight: 700,
      lineHeight: 28 / 20
    },
    subheader: {
      fontSize: 13,
      fontWeight: 700,
      lineHeight: 18 / 13
    },
    body02: {
      fontSize: 16,
      fontWeight: 500,
      lineHeight: 24 / 16
    },
    body01: {
      fontSize: 16,
      fontWeight: 400,
      lineHeight: 24 / 16
    },
    caption: {
      fontSize: 12,
      fontWeight: 400,
      lineHeight: 18 / 12
    }
  }, options);
};